import React, { useState, Component } from "react";
import "../../../../style/main.scss";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Slider from "react-slick";
import { Icon } from "@iconify/react";

const InstructionModal = ({ show, handleClose }) => {
  // const [show, setShow] = useState(false);

  // const handleClose = () => setShow(false);
  // const handleShow = () => setShow(true);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  return (
    <>
      <Modal show={show} onHide={handleClose} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title> </Modal.Title>
        </Modal.Header>
        <Modal.Body className="slider-body-modal">
          <h2> Must Read Instructions</h2>
          <Slider {...settings}>
            <div>
              <div className="content">
                <h5>Vital tips on how to type:</h5>
                <ul>
                  <li>
                    Don't type out ANY symbols or else you may confuse your AI.
                  </li>
                  <li>
                    <Icon icon="mdi:dot" width="30" height="30" />
                    Instead of “$” type out “dollar”.
                  </li>
                  <li>
                    <Icon icon="mdi:dot" width="30" height="30" />
                    Instead of “%” type out “percent”
                  </li>
                  <li>
                    <Icon icon="mdi:dot" width="30" height="30" />
                    Instead of “1-10” type out “one to ten”.
                  </li>
                  <li>
                    <Icon icon="mdi:dot" width="30" height="30" />
                    Instead of “voxr.ai” type out “voxr dot AI”.
                  </li>
                  <li>
                    When typing acronyms make sure to space them out. Instead of
                    “PDF” type out “P D F.” This is easier for your voxr to
                    understand.
                  </li>
                  <li>
                    Avoid starting lines in your script with fillers like
                    “uhhh”, “ummm”, “yah”, etc. voxr does this automatically
                    when it's thinking so by adding them in your script, voxr
                    might accidentally repeat itself.
                  </li>
                </ul>
              </div>
            </div>
            <div>
              <div className="content">
                <h5>How to insert variables:</h5>
                <ul>
                  <li>
                    <Icon icon="mdi:dot" width="30" height="30" />
                    Use "prospectName" to dynamically insert the prospects name
                    into the script.
                  </li>
                  <li>
                    <Icon icon="mdi:dot" width="30" height="30" />
                    Ex: “Hey, "prospectName"!”
                  </li>
                  <li>
                    <Icon icon="mdi:dot" width="30" height="30" />
                    **Note: "prospectName" is the only contact variable voxr
                    currently supports. We will be adding more (email, phone #,
                    etc) in some of our next few updates.
                  </li>
                  <li>
                    <Icon icon="mdi:dot" width="30" height="30" />
                    If you have a knowledge base attached, make sure to place
                    "knowledgeBase" where you want the context to be placed.
                  </li>
                  <li>
                    <Icon icon="mdi:dot" width="30" height="30" />
                    You can use [brackets] in your script when you want voxr to
                    fill in the blank with previous conversational context.
                  </li>
                  <li>
                    <Icon icon="mdi:dot" width="30" height="30" />
                    Ex: “Tell me more about [insert the problem the prospect
                    just stated here].”
                  </li>
                  <li>
                    <Icon icon="mdi:dot" width="30" height="30" />
                    ***But it is important you test this thoroughly via testing
                    your AI to make sure the way you worded it doesn't cause the
                    AI to say what's in the brackets outloud.
                  </li>
                </ul>
              </div>
            </div>
            <div>
              <div className="content">
                <h5>Final Tips:</h5>
                <ul>
                  <li>
                    <Icon icon="mdi:dot" width="30" height="30" />
                    To diminish the effect of any latency add this line
                    somewhere near the beginning of your script "and by the way,
                    the audio has been a bit laggy today so if i cut you off or
                    if there's a bit of a delay I apologize in advance"
                  </li>
                  <li>
                    <Icon icon="mdi:dot" width="30" height="30" />
                    Make sure to test & tweak your script A LOT before getting
                    voxr on live calls. The magic happens when testing your AI
                    and tweaking it until the details are great.
                  </li>
                </ul>
              </div>
            </div>
          </Slider>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default InstructionModal;
